export function validate(value: unknown, name: string): string {
  const isValid = typeof value === 'string' && value.length;

  if (!isValid) throw new Error(`ENV variable ${name} must be defined.`);

  return value;
}

export function getConfig() {
  return {
    auth0Domain: validate(import.meta.env.VITE_AUTH0_DOMAIN, 'VITE_AUTH0_DOMAIN'),
    auth0Audience: validate(import.meta.env.VITE_AUTH0_AUDIENCE, 'VITE_AUTH0_AUDIENCE'),
    auth0ClientId: validate(import.meta.env.VITE_AUTH0_CLIENT_ID, 'VITE_AUTH0_CLIENT_ID'),
    uploadEndpoint: validate(import.meta.env.VITE_UPLOAD_ENDPOINT, 'VITE_UPLOAD_ENDPOINT'),
    uploadUnsupportedFileEndpoint: validate(
      import.meta.env.VITE_UPLOAD_UNSUPPORTED_ENDPOINT,
      'VITE_UPLOAD_UNSUPPORTED_ENDPOINT',
    ),
    uploadXmlEndpoint: validate(import.meta.env.VITE_XML_UPLOAD_ENDPOINT, 'VITE_XML_UPLOAD_ENDPOINT'),
    uploadXlsEndpoint: validate(import.meta.env.VITE_XLS_UPLOAD_ENDPOINT, 'VITE_XLS_UPLOAD_ENDPOINT'),
    gqlApiEndpoint: validate(import.meta.env.VITE_GQL_ENDPOINT, 'VITE_GQL_ENDPOINT'),
    sendInvoiceEndpoint: validate(import.meta.env.VITE_MAIL_INVOICE_ENDPOINT, 'VITE_MAIL_INVOICE_ENDPOINT'),
    stripePublishableKey: validate(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY, 'VITE_STRIPE_PUBLISHABLE_KEY'),
    gaMeasurementId: validate(import.meta.env.VITE_GA_MEASUREMENT_ID, 'VITE_GA_MEASUREMENT_ID'),
    registerUrl: validate(import.meta.env.VITE_REGISTER_URL, 'VITE_REGISTER_URL'),
    gtmId: validate(import.meta.env.VITE_GTM_ID, 'VITE_GTM_ID'),
    hotjarId: validate(import.meta.env.VITE_HOTJAR_ID, 'VITE_HOTJAR_ID'),
    supportEmail: validate(import.meta.env.VITE_SUPPORT_EMAIL, 'VITE_SUPPORT_EMAIL'),
    salesEmail: validate(import.meta.env.VITE_SALES_EMAIL, 'VITE_SALES_EMAIL'),
    supportPhone: validate(import.meta.env.VITE_SUPPORT_PHONE, 'VITE_SUPPORT_PHONE'),
    salesPhone: validate(import.meta.env.VITE_SALES_PHONE, 'VITE_SALES_PHONE'),
    planOfRemindingUrl: 'https://www.upominej.cz/#upominani-faktur',
    termsAndConditionsUrl: 'https://www.upominej.cz/obchodni-podminky',
    gdprUrl: 'https://www.upominej.cz/gdpr',
    landingPageUrl: 'https://www.upominej.cz',
    stormwareXmlFormatUrl: 'https://www.stormware.cz/pohoda/xml/seznamschemat/',
    uploadSizeLimit: FILE_SIZE_LIMIT,
    drawerWidth: 225,
    universalTemplateUrl: '/assets/files/upominej-universal-template.xlsx',
    numberOfDefaultScenarios: 2,
    invoiceAppUrls: [
      'localhost:5174',
      'faktura.upominej.cz',
      'staging.faktura.upominej.cz',
      'faktura.newton.upominej.cz',
      'faktura.test.upominej.cz',
    ],
  };
}

export const MB = 1048576;
const FILE_SIZE_LIMIT = 50 * MB;
